import { type FC, useCallback, useEffect, useRef, useState } from 'react'

import { useUnit } from 'effector-react'

import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { $fanTimezone } from '@/models/chattingUI/chats/chats.ts'
import { openDialog } from '@/models/dialogs.ts'
import EditIcon from '@/modules/chatting/icons/edit.svg'
import { ListItem } from '@/modules/chatting/ui/chat-window/fan-info/ListItem.tsx'
import { getCurrentTimeInTimezone } from '@/modules/chatting/ui/chat-window/fan-info/utils.ts'
import { IconButton } from '@/modules/chatting/ui/components/icon-button.tsx'

export interface Props {}

export const LocalTime: FC<Props> = () => {
  const timezone = useUnit($fanTimezone)

  const [currentTime, setCurrentTime] = useState(
    getCurrentTimeInTimezone(timezone),
  )

  const intervalRef = useRef<NodeJS.Timeout>()

  const handleDialogOpen = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.EDIT_TIMEZONE,
    })
  }, [])

  useEffect(() => {
    const cleanup = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }

    if (!timezone) {
      setCurrentTime(getCurrentTimeInTimezone(timezone))
    }

    if (timezone) {
      cleanup()
      setCurrentTime(getCurrentTimeInTimezone(timezone))

      intervalRef.current = setInterval(() => {
        setCurrentTime(getCurrentTimeInTimezone(timezone))
      }, 1000)

      return cleanup
    }
  }, [timezone])

  return (
    <ListItem
      label="Local time"
      value={
        <>
          {currentTime}
          <IconButton
            icon={EditIcon}
            onClick={handleDialogOpen}
            className="text-primary-500"
          />
        </>
      }
    />
  )
}
